
function Button({ children, onClick, variant="primary", style={}, type="button", disabled=false }) {
  const map = {
    primary: "cc-btn-primary",
    dark: "cc-btn-dark",
    secondary: "cc-btn-secondary",
    danger: "cc-btn-danger",
    success: "cc-btn-success",
    blue: "cc-btn-blue",
  };
  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled}
      className={`cc-btn ${map[variant] || map.primary}`}
      style={style}
    >
      {children}
    </button>
  );
}
export default Button;
